export default __webpack_public_path__ + "static/media/banner.ddf35f74.png";